import { jsx as r } from "react/jsx-runtime";

import { TableBody as a } from "react-aria-components";

const e = ({children: e, className: o, ...t}) => r(a, {
    ...t,
    children: e
});

export { e as default };
//# sourceMappingURL=index.js.map
